import React from "react";
import { ROUTE_AUTH_CALLBACK, ROUTE_LOGIN } from "./const";
import { RedirectToLogin } from "components/redirect";
import { ErrorCodeType } from "store/useErrorStore";
import Error401Page from "pages/error/Error401";
import Error403Page from "pages/error/Error403";
import Error404Page from "pages/error/Error404";
import Error500page from "pages/error/Error500";

interface PrivateRouteProps {
  path: string;
  component?: React.LazyExoticComponent<() => React.JSX.Element>;
  fallback?: () => React.JSX.Element;
  errorCode?: ErrorCodeType;
  isLogin: boolean;
  isPermission?: boolean;
  exact?: boolean;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = (props) => {
  const {
    component: Component,
    fallback: Fallback,
    errorCode: ErrorCode,
    isPermission,
    isLogin,
    path,
  } = props;

  // 인증 콜백인 경우 로그인 상태와 관계없이 렌더링
  if (path === ROUTE_AUTH_CALLBACK && Component) {
    return <Component />;
  }
  // 컴포넌트를 조건에 따라 렌더링
  if (!isLogin && path !== ROUTE_LOGIN) {
    return <RedirectToLogin isLogin={isLogin} />;
  }
  if (ErrorCode === 401) return <Error401Page />;
  if (ErrorCode === 403) return <Error403Page />;
  if (ErrorCode === 404) return <Error404Page />;
  if (ErrorCode === 500) return <Error500page />;
  if (isPermission && Component) {
    return <Component />;
  } else if (Fallback) {
    return <Fallback />;
  } else {
    return null; // 항상 ReactElement 또는 null을 반환해야 합니다.
  }
};
